import React from "react";
import InfoIcon from "../../assets/images/topbar/information_sessionexpire.svg";
import { withTranslation } from "react-i18next";

const NotAvailable = (props) => {
    return (
        <div class="msg-container">
            <div class="message">
                <h1>
                    <img src={InfoIcon} alt="" class="info-icon" />
                    INFORMATION
                </h1>
                <div className="header_bottom_border"></div>
                <h2>
                    {props.t("dingdong_game_not_available_for_client")}
                </h2>
            </div>

        </div>
    );
};

export default withTranslation()(NotAvailable);
